(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
parcelRequire.register("9Was2", function(module, exports) {

$parcel$export(module.exports, "searchResults", () => $73c1a3395d65dc8d$export$c3c488c05aeea533);
function $73c1a3395d65dc8d$export$c3c488c05aeea533(selector) {
    const input_field = selector.querySelector("input");
    const result_list = selector.querySelector(".search-input-results");
    const json_path = input_field.dataset.searchurl;
    const all_results_url = input_field.dataset.searchresultsurl;
    const all_results_label = input_field.dataset.searchresultslabel;
    if (result_list) input_field.addEventListener("keyup", ()=>{
        if (input_field.value.length >= 3) {
            const json = new XMLHttpRequest();
            json.onload = function() {
                const response = JSON.parse(this.responseText);
                const results = response.results;
                if (results.length > 0) {
                    let content = "<ul>";
                    results.forEach((item)=>{
                        content += '<li><a href="' + item.url + '">' + "<strong>" + item.title + "</strong><br>" + item.type + "</a></li>";
                    });
                    if (all_results_label && all_results_url) result_list.innerHTML = content + "<li>" + '<a href="' + all_results_url + "?searchInput=" + input_field.value + '">' + "<strong>" + all_results_label + '</strong> <span class="icon icon-chevron-right"></span>' + "</a></li></ul>";
                    else result_list.innerHTML = content;
                }
            };
            json.open("GET", json_path + "?q=" + input_field.value);
            json.send();
        }
    });
}

});

})();
//# sourceMappingURL=search-input.fe4ad831.js.map
